module.exports = __webpack_public_path__ + "static/img/logo-junto-seguros.2f51bb0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-junto-seguros.jpeg
// module id = 8OYP
// module chunks = 1